<template>
    <div class="maintenance-detail">
        <div class="card border-0 shadow-sm">
            <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                <span class="mb-0 h3">
                    <i class="fas fa-clipboard-check mr-2 me-2"></i>
                    {{ datos.tipoMantenimientoDescripcion }} #{{ datos.mantenimiento_id }}
                </span>
                <span class="badge" :class="datos.estado ? 'bg-success' : 'bg-danger'">
                    {{ datos.estado ? 'Activo' : 'Inactivo' }}
                </span>
            </div>

            <!-- Documentos adjuntos -->
            <div class="card-body">
                <h5 class="mb-3 border-bottom pb-2 font-weight-bold">
                    <i class="fas fa-file-alt me-2"></i>Documentos Adjuntos
                </h5>
                <ul class="list-group list-group-flush mb-4">
                    <li class="list-group-item d-flex justify-content-between align-items-center"
                        v-if="datos.copia_autorizacion_viaje_nombre_original">
                        {{ datos.copia_autorizacion_viaje_nombre_original }}
                        <button class="btn btn-outline-primary btn-sm" @click="getDocumentoUrl(
                            datos.copia_autorizacion_viaje_ruta,
                            datos.copia_autorizacion_viaje_documento,
                            datos.copia_autorizacion_viaje_nombre_original
                        )">
                            Descargar
                        </button>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center"
                        v-if="datos.copia_documento_parentesco_nombre_original">
                        {{ datos.copia_documento_parentesco_nombre_original }}
                        <button class="btn btn-outline-primary btn-sm" @click="getDocumentoUrl(
                            datos.copia_documento_parentesco_ruta,
                            datos.copia_documento_parentesco_documento,
                            datos.copia_documento_parentesco_nombre_original
                        )">
                            Descargar
                        </button>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center"
                        v-if="datos.copia_documento_identidad_autorizado_nombre_original">
                        {{ datos.copia_documento_identidad_autorizado_nombre_original }}
                        <button class="btn btn-outline-primary btn-sm" @click="getDocumentoUrl(
                            datos.copia_documento_identidad_autorizado_ruta,
                            datos.copia_documento_identidad_autorizado_documento,
                            datos.copia_documento_identidad_autorizado_nombre_original
                        )">
                            Descargar
                        </button>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center"
                        v-if="datos.copia_constancia_entrega_nombre_original">
                        {{ datos.copia_constancia_entrega_nombre_original }}
                        <button class="btn btn-outline-primary btn-sm" @click="getDocumentoUrl(
                            datos.copia_constancia_entrega_ruta,
                            datos.copia_constancia_entrega_documento,
                            datos.copia_constancia_entrega_nombre_original
                        )">
                            Descargar
                        </button>
                    </li>
                </ul>

                <!-- Información general -->
                <div class="row mb-4">
                    <div class="col-md-6">
                        <p><strong>Fecha del viaje:</strong> {{ formatDate(datos.fecha_viaje) }}</p>
                        <p><strong>Origen:</strong> {{ datos.origen }}</p>
                        <p><strong>Destino:</strong> {{ datos.destino }}</p>
                    </div>
                    <div class="col-md-6">
                        <p><strong>Nombres del NNA:</strong> {{ datos.nombres_apellidos_nna }}</p>
                        <p><strong>Identificación NNA:</strong> {{ datos.numero_identificacion_nna }}</p>
                        <p><strong>Situación discapacidad:</strong> {{ datos.situacion_discapacidad }}</p>
                    </div>
                </div>

                <!-- Información del otorgante -->
                <div class="row mb-4">
                    <div class="col-md-6">
                        <p><strong>Otorgante:</strong> {{ datos.nombres_apellidos_otorgante }}</p>
                        <p><strong>Identificación:</strong> {{ datos.numero_identificacion_otorgante }}</p>
                        <p><strong>Teléfono:</strong> {{ datos.numero_telefonico_otorgante }}</p>
                    </div>
                    <div class="col-md-6">
                        <p><strong>Correo electrónico:</strong> {{ datos.correo_electronico_otorgante }}</p>
                        <p><strong>Dirección:</strong> {{ datos.direccion_fisica_otorgante }}</p>
                    </div>
                </div>

                <!-- Información del autorizado a viajar -->
                <div class="row mb-4">
                    <div class="col-md-6">
                        <p><strong>Autorizado a viajar:</strong> {{ datos.nombres_apellidos_autorizado_viajar }}</p>
                        <p><strong>Identificación:</strong> {{ datos.numero_identificacion_autorizado_viajar }}</p>
                    </div>
                    <div class="col-md-6">
                        <p><strong>Teléfono:</strong> {{ datos.numero_telefonico_autorizado_viajar }}</p>
                        <p><strong>Dirección:</strong> {{ datos.direccion_fisica_autorizado_viajar }}</p>
                    </div>
                </div>

                <!-- Información del autorizado a recoger -->
                <div class="row mb-4">
                    <div class="col-md-6">
                        <p><strong>Autorizado a recoger:</strong> {{ datos.nombres_apellidos_autorizado_recoger }}</p>
                        <p><strong>Identificación:</strong> {{ datos.numero_identificacion_autorizado_recoger }}</p>
                    </div>
                    <div class="col-md-6">
                        <p><strong>Teléfono:</strong> {{ datos.numero_telefonico_autorizado_recoger }}</p>
                        <p><strong>Dirección:</strong> {{ datos.direccion_fisica_autorizado_recoger }}</p>
                    </div>
                </div>
            </div>

            <div class="card-footer bg-light">
                <div class="row text-muted small">
                    <div class="col-md-6">
                        <i class="far fa-calendar-plus me-1"></i> Creado: {{ formatDate(datos.created_at) }}
                    </div>
                    <div class="col-md-6 text-md-end">
                        <i class="far fa-calendar-check me-1"></i> Actualizado: {{ formatDate(datos.updated_at) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
    name: "DetalleMantenimiento",
    props: {
        datos: {
            type: Object,
            required: true
        }
    },
    methods: {
        formatDate(dateString) {
            if (!dateString) return 'N/A';
            const date = new Date(dateString);
            return date.toLocaleString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        },
        async getDocumentoUrl(ruta, documento, nombreOriginalDocumento) {
            try {
                Swal.fire({
                    title: 'Descargando...',
                    text: 'Obteniendo documento desde la Super Transporte',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });
                const respuesta = await this.$store.dispatch('hl_get_file_cookie', {
                    path: `ApiSuperTransporteMantenimientos/descargar-archivo?documento=${documento}&ruta=${ruta}&nombreOriginal=${nombreOriginalDocumento}`,
                    responseType: "blob",
                })

                console.log("La data es:", ruta, documento, nombreOriginalDocumento);
                console.log("Documento:", respuesta);

                Swal.close();
            } catch (error) {
                Swal.close();
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Ocurrió un error al descargar el archivo'
                });
                console.error(error);
            }
        }

    }
}
</script>

<style scoped>
.maintenance-detail {
    max-width: 900px;
    margin: 0 auto;
}

.card {
    transition: all 0.3s ease;
}

.card:hover {
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.table th,
.table td {
    vertical-align: middle;
}

@media (max-width: 768px) {
    .card-footer .col-md-6:last-child {
        margin-top: 0.5rem;
        text-align: left !important;
    }
}
</style>